import { gql, useMutation } from '@apollo/client'
import { useRouter } from 'next/router'

const DELETE_PLAYLIST = gql`
  mutation DeletePlaylist($input: DeletePlaylistInput!) {
    deletePlaylist(input: $input) {
      playlistId
    }
  }
`

type Response = {
  deletePlaylist: {
    playlist: {
      id: string
    }
  }
}

type Variables = {
  input: {
    id: string
  }
}

export const useDeletePlaylist = () => {
  const router = useRouter()
  const isDashboard = router.pathname === '/dashboard'
  const [deleteRequest] = useMutation<Response, Variables>(DELETE_PLAYLIST, {
    ...((isDashboard) && {
      refetchQueries: ['GetPlaylist'],
    }),
    onCompleted() {
      if (!isDashboard) {
        router.back()
      }
    },
  })

  const deletePlaylist = async (id: string) => {
    return deleteRequest({ variables: { input: { id } } })
  }

  return {
    deletePlaylist,
  }
}
